module.exports = __webpack_public_path__ + "img/kyo_d200507c.daead563.jpg";